// Utils
import formatHtml from 'components/staticpages/formathtml'

import styles from './contactblock.css'

type ContactBlockProps = {
  value: {
    text: string
  }
}

const ContactBlock = ({ value: { text } }: ContactBlockProps): JSX.Element => (
  <div className={styles.container}>
    <div>
      <span className={styles.body} dangerouslySetInnerHTML={{ __html: formatHtml(text) }} />
    </div>
  </div>
)

export default ContactBlock
